import React, { useEffect, useState } from "react";
import { Container, Card, Button, Row, Col, Spinner } from "react-bootstrap";
import { motion, AnimatePresence } from "framer-motion";
import api from "../api/API";
import PlanejamentoDiaModal from "./PlanejamentoDiaModal";
import "./PlanejamentoSemanalPage.css";

const PlanejamentoSemanaPage = () => {

  const [semana, setSemana] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dataBase, setDataBase] = useState(new Date());
  const [showModal, setShowModal] = useState(false);
  const [diaSelecionado, setDiaSelecionado] = useState(null);

  useEffect(() => {
    carregarSemana();
  }, [dataBase]);

  async function carregarSemana() {
    try {
      setLoading(true);
      const { inicio, fim } = getSemanaIntervalo(dataBase);
      const res = await api.get(`/dias/intervalo?inicio=${inicio}&fim=${fim}`);
      setSemana(res.data || []);
    } catch (err) {
      console.error(err);
      setSemana([]);
    } finally {
      setLoading(false);
    }
  }

  function getSemanaIntervalo(data) {
    const base = new Date(data);
    base.setHours(0, 0, 0, 0);
    const diaSemana = base.getDay();
    const diff = diaSemana === 0 ? -6 : 1 - diaSemana;

    const inicio = new Date(base);
    inicio.setDate(base.getDate() + diff);

    const fim = new Date(inicio);
    fim.setDate(inicio.getDate() + 6);

    const formatar = (d) => {
        const ano = d.getFullYear();
        const mes = String(d.getMonth() + 1).padStart(2, "0");
        const dia = String(d.getDate()).padStart(2, "0");
        return `${ano}-${mes}-${dia}`;
    };

    return { inicio: formatar(inicio), fim: formatar(fim) };
  }

  function parseLocalDate(yyyyMMdd) {
    const [y, m, d] = yyyyMMdd.split("-").map(Number);
    return new Date(y, m - 1, d); // local, sem UTC
  }


  function formatarData(data) {
    return parseLocalDate(data).toLocaleDateString("pt-BR", {
      day: "numeric",
      month: "long"
    });
  }

  function semanaAnterior() {
    const nova = new Date(dataBase);
    nova.setDate(nova.getDate() - 7);
    setDataBase(nova);
  }

  function proximaSemana() {
    const nova = new Date(dataBase);
    nova.setDate(nova.getDate() + 7);
    setDataBase(nova);
  }

  function semanaAtual() {
    setDataBase(new Date());
  }

  async function abrirDia(data) {
    try {
      const res = await api.get(`/dias/por-data/${data}`);
      console.log("DataSelecionada:", res.data);
      setDiaSelecionado(res.data);
      setShowModal(true);
    } catch (err) {
      console.error(err);
    }
  }

  // Resumo da Semana
  const totalPlanejadas = semana.reduce(
    (acc, d) => acc + parseInt(d.tarefas_planejadas  || 0),
    0
  );

  const totalConcluidas = semana.reduce(
    (acc, d) => acc + parseInt(d.tarefas_concluidas  || 0),
    0
  );

  const percentual =
    totalPlanejadas > 0
      ? Math.round((totalConcluidas / totalPlanejadas) * 100)
      : 0;

  const { inicio, fim } = getSemanaIntervalo(dataBase);

  return (
    <Container className="semana-container">

      {/* HEADER */}
      <div className="semana-header">

        <button className="nav-btn" onClick={semanaAnterior}>
            ←
        </button>

        <div className="semana-hero">

            <small className="semana-label">SEMANA</small>

            <h1>
            {formatarData(inicio)} — {formatarData(fim)}
            </h1>

            <div className="semana-kpi">
            <div className="kpi-numero">{percentual}%</div>
            <div className="kpi-sub">
                {totalConcluidas} de {totalPlanejadas} tarefas concluídas
            </div>
            </div>

            <div className="progress-wrapper">
            <div
                className="progress-fill"
                style={{ width: `${percentual}%` }}
            />
            </div>

            <button
            className="btn-semana-atual"
            onClick={semanaAtual}
            >
            Semana atual
            </button>

        </div>

        <button className="nav-btn" onClick={proximaSemana}>
            →
        </button>

      </div>

      {/* TRANSIÇÃO SUAVE */}
      <AnimatePresence mode="wait">
        <motion.div
          key={inicio}
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -30 }}
          transition={{ duration: 0.25 }}
        >
          {loading ? (
            <div className="text-center mt-5">
              <Spinner />
            </div>
          ) : (
            <Row className="dias-grid">
              {semana.map((dia, index) => {
              
              console.log("DIA RECEBIDO:", JSON.stringify(dia, null, 2));

              return (
                
                <Col md={4} key={index} className="mb-4">
                  <Card
                    className={`dia-card ${
                        new Date(dia.data).toDateString() === new Date().toDateString()
                        ? "today"
                        : ""
                    }`}
                    onClick={() => abrirDia(dia.data)}
                  >
                    <small>
                      {new Date(dia.data).toLocaleDateString("pt-BR", {
                        weekday: "long"
                      }).toUpperCase()}
                    </small>

                    <div className="dia-numero">
                      {new Date(dia.data).getDate()}
                    </div>

                    

                    {Number(dia.tarefas_planejadas) > 0 ? (
                    <div className="dia-badges">
                        <span>{dia.tarefas_planejadas} tarefas</span>
                        <span>
                        {dia.tarefas_concluidas }/{dia.tarefas_planejadas}
                        </span>
                    </div>
                    ) : (
                    <div className="dia-empty">
                        Sem planejamento
                    </div>
                    )}
                  </Card>
                </Col>
              )})}
            </Row>
          )}
        </motion.div>
      </AnimatePresence>

      {diaSelecionado && (
        <PlanejamentoDiaModal
          show={showModal}
          onHide={() => setShowModal(false)}
          dia={diaSelecionado}
          onSaved={() => {
            setShowModal(false);
            carregarSemana();
          }}
        />
      )}
    </Container>
  );
};

export default PlanejamentoSemanaPage;
